<main data-qa="unauthorized-page">
	<div class="page-layout">
		<div class="content">
			<h1>401</h1>
			<div class="main-text">
				<div>
					<div class="heading">
						<div class="icon">
							<app-icon
								icon="misuse-outline"
								iconSize="64"
							></app-icon>
						</div>
						<div class="text">Unauthorised</div>
					</div>
					<p class="description-text">Looks like you have not logged in.</p>
					<div class="description">
						<p class="mt-3 description-text">
							Go back to the <a href="/login">login page</a> and enter your login details.
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</main>
